__turbopack_context__.v({
  "enhancedCard": "EnhancedTaxReturnDeliveryCard-module__QVjiEq__enhancedCard",
});
